const updateIntercom = data => {
  if (window && window.Intercom) {
    window.Intercom('update', data);
  }
};

export default updateIntercom;



// WEBPACK FOOTER //
// ./src/utils/updateIntercom.js